import { render, staticRenderFns } from "./info-new-offers.vue?vue&type=template&id=33159ea4&scoped=true&"
var script = {}
import style0 from "./info-new-offers.vue?vue&type=style&index=0&id=33159ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33159ea4",
  null
  
)

export default component.exports